var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('v-card',{staticClass:"mx-auto pa-5",attrs:{"max-width":"900"}},[_c('v-card-title',[_vm._v(" Comments / Suggestions / Help Request ")]),_c('v-container',[_c('contact-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }